// ===========================================
// components/MastiCategoryTable.jsx
// ===========================================

import { IconButton } from "@mui/material";
import React from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";

const MastiCategoryTable = ({ categories, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="rounded-xl bg-white p-10 text-center shadow-sm">
        Loading...
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-sm">
      <table className="w-full">
        <thead className="bg-pink-50">
          <tr>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">
              Order Slot
            </th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">
              Name
            </th>

            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">
              Description
            </th>

            <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          {categories?.length > 0 ? (
            categories.map((item, index) => (
              <tr key={item._id} className="border-t border-gray-100">
                <td className="px-6 py-4 text-sm text-gray-700">
                  {item?.order}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">{item.name}</td>

                <td className="px-6 py-4 text-sm text-gray-700">
                  {item.description || "-"}
                </td>

                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-3">
                    <IconButton color="primary" onClick={() => onEdit(item)}>
                      <FaEdit size={16} />
                    </IconButton>

                    <IconButton
                      color="error"
                      onClick={() => onDelete(item._id)}
                    >
                      <FaTrash size={12} />
                    </IconButton>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={3}
                className="px-6 py-10 text-center text-sm text-gray-500"
              >
                No categories found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MastiCategoryTable;
